import React, { FC, ReactNode } from 'react';
import { withSuffix } from 'src/common/utils/dataAttributeHelpers';
import getClassNames from '../../utils/getClassNames';

import styles from './Button.module.scss';

export type ButtonProps = {
  children: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  value?: any;
  onClick?: () => void;
  disabled?: boolean;
  classNameModifier?: string;
  submitting?: boolean;
  form?: string;
  'data-test'?: string;
};

const Button: FC<ButtonProps> = ({
  type = 'submit',
  value,
  onClick,
  children,
  submitting,
  disabled,
  classNameModifier = '',
  form,
  'data-test': dataTest,
}) => {
  const className = getClassNames(styles, 'root', `${classNameModifier} ${submitting ? 'wait' : ''}`);

  let buttonContent: ReactNode;
  if (submitting && classNameModifier === 'trip message') {
    buttonContent = '';
  } else if (submitting) {
    buttonContent = 'Please Wait...';
  } else {
    buttonContent = children;
  }

  return (
    <button
      // The type is provided by the caller.
      // eslint-disable-next-line react/button-has-type
      type={type}
      value={value}
      onClick={onClick}
      className={className}
      disabled={disabled || submitting}
      form={form}
      data-test={withSuffix(dataTest, 'button')}
    >
      {buttonContent}
    </button>
  );
};

export default Button;
